'use strict';

var _ = require('lodash');
var MappedFaresGridTransformerFactory = function MappedFaresGridTransformerFactory(DataTransformer, momentService, configurationService, fcrService) {
  function MappedFaresGridTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'mapped-fares-mode';
    this.targetType = 'mapped-fares';
    this.priority = 1;
  }
  MappedFaresGridTransformer.prototype = Object.create(DataTransformer.prototype);
  MappedFaresGridTransformer.constructor = MappedFaresGridTransformer;
  MappedFaresGridTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  MappedFaresGridTransformer.prototype.isCacheable = function () {
    return true;
  };
  MappedFaresGridTransformer.prototype.getCacheKey = function () {
    return this.sourceType + '-' + this.targetType;
  };
  MappedFaresGridTransformer.prototype.transform = function (data) {
    var results = data.domain.results;
    var finalResult = [];
    var market = getMarket(results);
    var fcrTag = fcrService.getFcrTagForCurrentDateWithMarket(market);
    var classesIndexes = configurationService.getClassIndexMapping(market, fcrTag);
    for (var index = 0, dataLength = results.length; index < dataLength; index++) {
      var element = results[index];
      element.market = market;
      element.origin = element.marketOrigin;
      element.destination = element.marketDestination;
      element.applicableDateRangeBegin = momentService.of(element.applicableDateRangeBegin, momentService.FIELD.APPLICABLE_DATE_RANGE);
      element.applicableDateRangeEnd = momentService.of(element.applicableDateRangeEnd, momentService.FIELD.APPLICABLE_DATE_RANGE);
      element.lastProcessedDateMoment = momentService.of(element.eventTimeStamp, momentService.FIELD.EVENT_TIME_STAMP);
      element.classIndex = classesIndexes[element.className];
      finalResult.push(element);
    }
    return _.sortBy(finalResult, function (element) {
      return element.classIndex;
    });
  };
  function getMarket(data) {
    var firstElement = data[0];
    return firstElement ? firstElement.marketOrigin + '-' + firstElement.marketDestination : '';
  }
  return MappedFaresGridTransformer;
};
MappedFaresGridTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService', 'ConfigurationService', 'FcrService'];
module.exports = MappedFaresGridTransformerFactory;